import { SituacaoDiagnosticoType } from '../../../../../../_metronic/helpers'
import { AtendimentoView } from '../../../atendimento/core/_models'

/**
 * O que falta no diagnóstico para finalizar, olhando a tela e o gravado juntos; `null` quando
 * pronto. O backend só confere o gravado, então uma situação limpa no select, ainda sendo gravada
 * ou "Diagnosticado" sem CID passaria; aqui ela bloqueia.
 *
 * @param situacaoNaTela situação escolhida no select, gravada ou não
 */
export const pendenciaDiagnostico = (
  atendimento: Pick<AtendimentoView, 'cids' | 'situacaoDiagnostico'>,
  situacaoNaTela: SituacaoDiagnosticoType | undefined
): string | null => {
  if (atendimento.cids?.length) return null
  if (!situacaoNaTela) return 'Informe a situação diagnóstica ou adicione um CID.'
  if (situacaoNaTela === SituacaoDiagnosticoType.Diagnosticado) return 'Adicione ao menos um CID.'
  if (situacaoNaTela !== atendimento.situacaoDiagnostico) {
    return 'Aguarde a situação diagnóstica ser salva.'
  }
  return null
}
